(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      const t = this.getAttribute('data-sticky-type');
      if (t === 'always' || t === 'on-scroll-up') {
        this.classList.add('ms-nav-zone--sticky');
      }
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--ms-header-height', `${this.offsetHeight}px`);
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  class NavDrawer extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.ms-top-nav__link');
      this.drawer = this.querySelector('.ms-drawer-grid');
      if (!this.button || !this.drawer) return;

      this.closeDelay = 150; // ms — forgiveness window for mouse to travel
      this.closeTimer = null;

      // v1.3 force-recompile
      const backdrop = document.querySelector('[data-ms-drawer-backdrop]');
      const open = () => {
        clearTimeout(this.closeTimer);
        this.button.setAttribute('aria-expanded', 'true');
        this.button.classList.add('is-open');
        this.drawer.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-open');
      };
      const close = () => {
        this.button.setAttribute('aria-expanded', 'false');
        this.button.classList.remove('is-open');
        this.drawer.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
      };
      const scheduleClose = () => {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(close, this.closeDelay);
      };
      const cancelClose = () => clearTimeout(this.closeTimer);

      // Open on hover/focus of the trigger.
      this.button.addEventListener('mouseenter', open);
      this.button.addEventListener('focus', open);

      // Keep open while mouse is inside the drawer; close shortly after it leaves.
      this.drawer.addEventListener('mouseenter', cancelClose);
      this.drawer.addEventListener('mouseleave', scheduleClose);

      // Schedule close when mouse leaves the trigger — cancelled if the
      // user reaches the drawer within the delay window.
      this.button.addEventListener('mouseleave', scheduleClose);

      // The trigger is an <a> with a real href, so a plain click navigates
      // to the link's URL (e.g. /collections/all). Clicks on the caret
      // toggle the drawer instead of navigating — useful for users who
      // want to browse the mega-menu without leaving the current page.
      const caret = this.button.querySelector('.ms-caret');
      if (caret) {
        caret.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.button.classList.contains('is-open') ? close() : open();
        });
      }

      // Escape closes immediately.
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { cancelClose(); close(); }
      });
    }
  }
  if (!customElements.get('nav-drawer')) customElements.define('nav-drawer', NavDrawer);

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-ms-mobile-toggle]');
    if (!t) return;
    const drawer = document.querySelector('[data-ms-mobile-drawer]');
    if (drawer) drawer.classList.toggle('is-open');
    t.classList.toggle('is-open');
  });

  } catch(e) { console.error(e); }
})();
})();
